import React from "react";
import "../styles.css";

const Shop = () => (
  <div className="page-container store-page">
    <section className="store-hero">
      <p className="eyebrow">X Fire Music Central Highlands</p>
      <h1>Visit Our Music Store in Emerald</h1>
      <p className="store-intro">
        X Fire Music now focuses on serving musicians in person from our Central Highlands store.
        Drop in for instruments, accessories, friendly advice and the local service you already know us for.
      </p>

      <div className="store-actions">
        <a
          className="store-btn primary"
          href="https://www.google.com/maps/search/?api=1&query=X%20Fire%20Music%20Central%20Highlands%2C%2010%20Hospital%20Rd%2C%20Emerald%20QLD%204720"
          target="_blank"
          rel="noreferrer"
        >
          Get Directions
        </a>
        <a className="store-btn" href="tel:+61457170347">
          Call 0457 170 347
        </a>
      </div>
    </section>

    <section className="store-grid">
      <div className="store-card">
        <h2>Find Us</h2>
        <p>
          <strong>X Fire Music Central Highlands</strong><br />
          10 Hospital Rd<br />
          Emerald QLD 4720
        </p>
        <p>
          <a href="mailto:info@xfiremusic.com.au">info@xfiremusic.com.au</a>
        </p>
      </div>

      <div className="store-card">
        <h2>Opening Hours</h2>
        <div className="hours-list">
          <div><span>Monday</span><strong>Closed</strong></div>
          <div><span>Tuesday</span><strong>9:30am – 5:00pm</strong></div>
          <div><span>Wednesday</span><strong>9:30am – 5:00pm</strong></div>
          <div><span>Thursday</span><strong>9:30am – 5:00pm</strong></div>
          <div><span>Friday</span><strong>9:30am – 5:00pm</strong></div>
          <div><span>Saturday</span><strong>9:30am – 1:00pm</strong></div>
          <div><span>Sunday</span><strong>Closed</strong></div>
        </div>
      </div>
    </section>

    <section className="map-card" aria-label="Map showing X Fire Music Central Highlands">
      <iframe
        title="X Fire Music Central Highlands map"
        src="https://www.google.com/maps?q=10%20Hospital%20Rd%2C%20Emerald%20QLD%204720&output=embed"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    </section>

    <section className="store-note">
      <h2>Come and visit us</h2>
      <p>
        Our team can help you find the perfect musical instruments and equipment.
        bring your questions and ideas, and we’ll help you make them a reality. We look forward to seeing you in our store soon!
      </p>
    </section>
  </div>
);

export default Shop;
